// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";
import { useAuth } from "@/contexts/AuthContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AuthCallback() {
  const navigate = useNavigate();
  const hasProcessed = useRef(false);
  const { setUser } = useAuth();

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) {
      navigate("/admin/login", { replace: true });
      return;
    }
    const session_id = m[1];

    (async () => {
      try {
        const r = await axios.post(`${API}/auth/session`, { session_id }, { withCredentials: true });
        setUser(r.data);
        // Clean hash and go to dashboard
        window.history.replaceState({}, document.title, "/admin");
        navigate("/admin", { replace: true, state: { user: r.data } });
      } catch (e) {
        const detail = e?.response?.data?.detail || "Sign-in failed";
        toast.error(detail);
        navigate("/admin/login", { replace: true });
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[var(--beige-50)]">
      <p className="text-[var(--ink-soft)] font-serif italic">Signing you in…</p>
    </div>
  );
}
